import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import Snackbar from '~/components/Snackbar';
import { useAuth } from '~/context/auth';
import { NO_PAG_LIST_OFFSET } from '~/data/constants';
import { InstituteType } from '~/data/models/institute';
import { Country } from '~/data/models/marketProfile';
import {
  INSTITUTE_TYPES,
  REQUEST_MISSING_INSTITUTE,
} from '~/data/operations/institute';
import {
  InstitutesInstituteCountryChoices,
  RequestMissingInstituteInput,
} from '~/data/types/graphql';
import { GroupStackParamList } from '~/navigation/types';
import RequestInstitutionLayout from './layout';

type RequestInstitutionNavProp = StackNavigationProp<
  GroupStackParamList,
  'RequestInstitution'
>;

export default function RequestInstitution(): JSX.Element {
  const navigation = useNavigation<RequestInstitutionNavProp>();

  const { country, onUpdateCountry } = useAuth();

  const { data: instituteTypesData } = useQuery(INSTITUTE_TYPES, {
    variables: {
      first: NO_PAG_LIST_OFFSET,
      country: country && InstitutesInstituteCountryChoices[country],
    },
  });
  const instituteTypes: InstituteType[] =
    (instituteTypesData?.instituteTypes?.edges.map(
      (edge) => edge?.node,
    ) as InstituteType[]) || [];

  const [requestMissingInstitute, { loading }] = useMutation(
    REQUEST_MISSING_INSTITUTE,
  );

  async function onRequestCreation({
    name,
    website,
    zip,
    city,
    country,
    street,
    type,
  }: RequestMissingInstituteInput) {
    try {
      const { data } = await requestMissingInstitute({
        variables: {
          input: {
            name,
            zip,
            city,
            website,
            country,
            street,
            type,
          },
        },
      });
      if (data?.requestMissingInstitute?.message) {
        navigation.navigate('RequestInstitutionSent');
      }
    } catch (e) {
      if (e instanceof Error) {
        Snackbar.show(e.message);
      }
    }
  }

  return (
    <RequestInstitutionLayout
      country={country as Country}
      instituteTypes={instituteTypes}
      loading={loading}
      onBack={() => navigation.goBack()}
      onUpdateCountry={onUpdateCountry}
      onRequestCreation={onRequestCreation}
    />
  );
}

/**
 * TODO:
 * - Handle address and schoolTypeKey
 */
